import { withTeamDialogLink } from "@/utils/teamDialogLink";

import type { TeamModel } from "@/models/TeamModel";

export function getBillingReturnPath(team: TeamModel) {
  const { pathname, search, hash } = window.location;
  return withTeamDialogLink(`${pathname}${search}${hash}`, {
    tab: "billing",
    teamPermalink: team.permalink,
  });
}
